import { BULK_PAYMENT_CALCULATION_DONE } from 'constants/events/bulkPayment';

export default response => dispatch =>
  dispatch({
    type: BULK_PAYMENT_CALCULATION_DONE,
    payload: response,
  });
